import React from 'react';
import SatButton from '@components/common/satUI/SatButton';
import { toSummaryName } from '@common/utils/index';

const EaPartSubLnb = props => {
  const {
    title1Status,
    setTitle1Status,
    title2Status,
    setTitle2Status,
    planMainInfo,
    onClickEaCloseBtn,
    currentPage,
    handlePageChange,
    completePage,
    bookmark,
    title3Status,
    setTitle3Status,
    onClickEaBookmark,
    pdfPageNum,
    completePdfPage,
  } = props;
  return (
    <nav className="nav app">
      <div className="tit-box">
        <h3 className="insu-tit" onClick={() => handlePageChange(0)}>
          {planMainInfo.mainProductName}
        </h3>
        <ul className="customer-info">
          {planMainInfo.mainProductName !== '' &&
          planMainInfo.insuredPrspCustNo === planMainInfo.ownerPrspCustNo ? (
            <li>{`계약자 / 피보험자 : ${toSummaryName(
              planMainInfo.insuredPrspInfo.name,
            )} (${planMainInfo.insuredPrspInfo.insuranceAge}세/${
              planMainInfo.insuredPrspInfo.genderLabel
            })`}</li>
          ) : (
            <>
              <li>{`계약자 : ${toSummaryName(
                planMainInfo.ownerPrspInfo.name,
              )} (${planMainInfo.ownerPrspInfo.insuranceAge}세/${
                planMainInfo.ownerPrspInfo.genderLabel
              })`}</li>
              <li>{`피보험자 : ${toSummaryName(
                planMainInfo.insuredPrspInfo.name,
              )} (${planMainInfo.insuredPrspInfo.insuranceAge}세/${
                planMainInfo.insuredPrspInfo.genderLabel
              })`}</li>
            </>
          )}
        </ul>
      </div>
      <ul className="app-step">
        <li className={`${title1Status ? 'complete' : ''}`}>
          <span
            className={`${title1Status && 'open'} ${
              currentPage > 0 && currentPage < 4 ? 'active' : ''
            }`}
            onClick={() => {
              setTitle1Status(!title1Status);
            }}
          >
            1. 본인 인증 및 서명 동의
          </span>
          <ul
            className="sub-step"
            style={title1Status ? { display: 'block' } : {}}
          >
            <li>
              <span
                className={`${
                  currentPage > 0 && currentPage < 2 ? 'active' : ''
                } ${completePage.includes(1) ? 'complete' : ''}`}
                onClick={() => handlePageChange(1)}
              >
                본인 인증
              </span>
            </li>
            <li>
              <span
                className={`${currentPage === 2 ? 'active' : ''} ${
                  completePage.includes(2) ? 'complete' : ''
                }`}
                onClick={() => handlePageChange(2)}
              >
                전자문서 서명 동의
              </span>
            </li>
            <li>
              <span
                className={`${currentPage === 3 ? 'active' : ''} ${
                  completePage.includes(3) ? 'complete' : ''
                }`}
                onClick={() => handlePageChange(3)}
              >
                고객정보 확인
              </span>
            </li>
          </ul>
        </li>
        <li className={`${title2Status ? 'complete' : ''}`}>
          <span
            className={`${title2Status && 'open'} ${
              currentPage === 4 ? 'active' : ''
            }`}
            onClick={() => {
              setTitle2Status(!title2Status);
            }}
          >
            2. 청약관련 문서
          </span>
          <ul
            className="sub-step"
            style={title2Status ? { display: 'block' } : {}}
          >
            {bookmark.map((data, index) =>
              data.dept === 1 && data.ableYn ? (
                data.title === '해약환급금 예시표' ||
                data.title === '해지환급금 예시표' ? (
                  <li key={index}>
                    <strong className="depth-2-tit">{data.title}</strong>
                  </li>
                ) : (
                  <li key={index}>
                    <span
                      className={`${
                        data.pn.split(',').includes(pdfPageNum) ? 'active' : ''
                      } ${
                        completePdfPage.includes(data.code) ? 'complete' : ''
                      }`}
                      onClick={() => onClickEaBookmark(data.pn)}
                    >
                      {data.title}
                    </span>
                  </li>
                )
              ) : null,
            )}
            {/* <li>
              <span
                className={`${currentPage === 9 ? 'active' : ''} ${
                  completePage.includes(9) ? 'complete' : ''
                }`}
                onClick={() => handlePageChange(9)}
              >
                {'보험설계사 서명'}
              </span>
            </li> */}
          </ul>
        </li>
        <li>
          <span
            className={`${title3Status && 'open'} ${
              currentPage > 4 ? 'active' : ''
            }`}
            onClick={() => {
              setTitle3Status(!title3Status);
            }}
          >
            3. 보완 완료
          </span>
          <ul
            className="sub-step"
            style={title3Status ? { display: 'block' } : {}}
          >
            <li>
              <span
                className={`${currentPage === 5 ? 'active' : ''} ${
                  completePage.includes(5) ? 'complete' : ''
                }`}
                onClick={() => handlePageChange(5)}
              >
                보완완료
              </span>
            </li>
          </ul>
        </li>
      </ul>
      <div className="nav-bottom">
        <SatButton
          styleClass="btn-s blue btn-wide"
          onClick={() => onClickEaCloseBtn()}
          label="전자청약 닫기"
          iconStyleClass="ico ico-exit"
        ></SatButton>
      </div>
    </nav>
  );
};

export default EaPartSubLnb;
